export default __webpack_public_path__ + "static/media/subject-civics.884d35ea.webp";